import { Component} from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, LazyLoadEvent, Message, SelectItem } from 'primeng/api';
import { DataTable } from 'primeng/components/datatable/datatable';
import { NotificationContentType } from '../../models/inModels/MessageModel';
import { Reward } from '../../models/inModels/Rewards';
import { RewardsService } from '../../services/rewards/rewards.service';

@Component({
  selector: 'app-rewards',
  templateUrl: './rewards.component.html',
  styleUrls: ['./rewards.component.css']
})
export class RewardsComponent {
  items: Reward[];
  rows: SelectItem[];
  selectedRows: number;
  filteredRecords: number;
  rowEvent: LazyLoadEvent;
  loading: boolean;
  totalRecords: number;
  error: Message[];
  contentId: number;
  contentType: NotificationContentType;
  sendAllDialog = false;
  selectedReward: Reward;
  
  constructor(
    	private service: RewardsService,
		private router: Router,
		private confirmationService: ConfirmationService) {
      this.loading = true;
      this.rows = [];
      this.rows.push({ label: '10', value: 10 });
      this.rows.push({ label: '25', value: 25 });
      this.rows.push({ label: '50', value: 50 });
      this.selectedRows = 10;
  }
  changeRows(event): void {
		this.load(this.rowEvent);
  }
  
  reset(dt: DataTable, gb: HTMLInputElement) {
		gb.value = '';
		dt.reset();
  }
  
  load(event: LazyLoadEvent): void {
    this.loading = true;
		event.rows = this.selectedRows;
		this.rowEvent = event;
		this.service.search(event).then(
			dataPager => {
				this.items = dataPager.Data;
				console.log(this.items);
				this.filteredRecords = dataPager.FilteredRecords;
				this.totalRecords = dataPager.TotalRecords;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.items = [];
				this.totalRecords = 0;
				this.filteredRecords = 0;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
  }
  edit(reward: Reward) {
	console.log(reward);
	this.router.navigate(['rewards/edit', reward.Id]);
  }
	
	viewRedeemers(reward: Reward) {
		console.log(reward);
		this.router.navigate(['rewards/view', reward.Id]);
  }
	
  delete(reward: Reward) {
		this.confirmationService.confirm({
			message: `Are you sure you want to delete <strong>${reward.CompanyName}</strong> reward?`,
			header: 'Confirmation',
			icon: 'fa fa-trash-o',
			accept: () => {
				this.loading = true;
				this.service.delete(reward.Id).then(
					result => {
						this.loading = false;
						this.load(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
	}
	
	goToTags() {
		this.router.navigate(['tags/manage']);
	}
	
}



// WEBPACK FOOTER //
// ./src/app/components/rewards/rewards.component.ts